import React, {useMemo} from 'react';
import {useSiteConfig} from '../../data/ConfigContext';
import {filterByCompetition, gameKey, upcomingGames} from '../../data/games';
import Game from './Game';

/** The next games of the competitions selected in settings.mainpage_matches. */
const UpcomingGames = ({limit = 3}: { limit?: number }) => {
    const config = useSiteConfig();

    const games = useMemo(() => {
        if (!config) return [];
        const competitions = config.settings.mainpage_matches?.map(filter => filter.filter_name) ?? [];
        return filterByCompetition(upcomingGames(config.appointments), competitions).slice(0, limit);
    }, [config, limit]);

    if (!config) {
        return (
            <div className="upcoming-games" aria-hidden="true">
                {Array.from({length: limit}, (_, i) => <div key={i} className="skeleton"/>)}
            </div>
        );
    }
    if (!games.length) return <p className="empty-state">Derzeit sind keine Spiele angesetzt.</p>;

    return (
        <div className="upcoming-games">
            {games.map(game => <Game key={gameKey(game)} game={game} variant="card"/>)}
        </div>
    );
};

export default UpcomingGames;
